import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_PAYMENTMODE_INIT_ACTION,
  FETCH_PAYMENTMODE_SUCCESS_ACTION,
  FETCH_PAYMENTMODE_FAIL_ACTION,
  ADD_PAYMENTMODE_INIT_ACTION,
  ADD_PAYMENTMODE_SUCCESS_ACTION,
  ADD_PAYMENTMODE_FAIL_ACTION,
  EDIT_PAYMENTMODE_INIT_ACTION,
  EDIT_PAYMENTMODE_SUCCESS_ACTION,
  EDIT_PAYMENTMODE_FAIL_ACTION,
  DELETE_PAYMENTMODE_INIT_ACTION,
  DELETE_PAYMENTMODE_SUCCESS_ACTION,
  DELETE_PAYMENTMODE_FAIL_ACTION
} from "./action";
//import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//var btoa = require("Base64").btoa;
//var history = createBrowserHistory();

function* fetchpaymentmodelist(value) {
  // console.log(value);
  let pageno = value.value === undefined ? 1 : value.value;
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(
      `${appConfig.ip}/paymentMode?limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PAYMENTMODE_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PAYMENTMODE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* AddPaymentMode(value) {
  // console.log(value);
  try {
    const token = localStorage.getItem("token");

    const data = {
      name: value.value.payMode,
      disc: value.value.payModeDescp,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/paymentMode`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({ type: FETCH_PAYMENTMODE_INIT_ACTION });
      yield put({
        type: ADD_PAYMENTMODE_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Payment Mode added successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_PAYMENTMODE_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* EditPaymentMode(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      name: value.value.payMode,
      disc: value.value.payModeDescp
    };

    const res = yield fetch(`${appConfig.ip}/paymentMode/` + value.value.id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({ type: FETCH_PAYMENTMODE_INIT_ACTION });
      yield put({
        type: EDIT_PAYMENTMODE_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Payment Mode updated successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_PAYMENTMODE_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* DeletePaymentMode(value) {
  let id = value.value;
  // let data = {
  //   isActive: false
  // };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/paymentMode/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify()
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_PAYMENTMODE_INIT_ACTION });
      yield toast.success("Deleted successfully", {
        autoClose: 3000
      });
      const resJSON = yield res.json();

      yield put({
        type: DELETE_PAYMENTMODE_SUCCESS_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_PAYMENTMODE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* paymentmodeActionWatcher() {
  yield takeEvery(FETCH_PAYMENTMODE_INIT_ACTION, fetchpaymentmodelist);
  yield takeEvery(ADD_PAYMENTMODE_INIT_ACTION, AddPaymentMode);
  yield takeEvery(EDIT_PAYMENTMODE_INIT_ACTION, EditPaymentMode);
  yield takeEvery(DELETE_PAYMENTMODE_INIT_ACTION, DeletePaymentMode);
}
